import React from "react";
import Skeleton from "./Skeleton";
import "./loaders.css";

/**
 * Skeleton placeholder that mirrors a data table while it loads.
 * Pass either an array of column labels or a column count.
 */
const TableSkeleton = ({ columns = 5, rows = 8 }) => {
  const columnList = Array.isArray(columns)
    ? columns
    : Array.from({ length: columns }, () => "");
  const columnCount = columnList.length;

  return (
    <div className="table-responsive" aria-busy="true" aria-live="polite">
      <table className="table align-middle table-bordered xc-skel-table mb-0">
        <thead className="manage-page-group-table-header xcruit-table">
          <tr>
            {columnList.map((label, index) => (
              <th key={index}>{label || <Skeleton width="60%" height="0.7rem" />}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columnCount }).map((__, colIndex) => (
                <td key={colIndex}>
                  <Skeleton
                    width={colIndex === 0 ? "85%" : "60%"}
                    height="0.85rem"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
